<script setup>
defineProps({
    bottomBorder: Boolean
});
</script>

<template>
  <div class="shadow-sm bg-white dark:bg-dark-blue rounded-lg">
        <slot/>
    </div>
</template>
